import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-align-center p-justify-center" }
const _hoisted_2 = { class: "field-checkbox" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-ml-2",
  for: "myself"
}, "To myself", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-px-2" }, "- OR -", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_UserAutocomplete = _resolveComponent("UserAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, _mergeProps({
    modal: true,
    class: "p-fluid",
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0,
    header: "Assign Notification"
  }, _ctx.$attrs, { style: {width: '500px'} }), {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Assign",
        icon: "pi pi-check",
        class: "p-button-primary",
        onClick: _ctx.onAssign
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Cancel",
        class: "p-button-info",
        icon: "pi pi-times",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', false)))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Checkbox, {
              id: "myself",
              modelValue: _ctx.toMyself,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.toMyself = $event)),
              onChange: _ctx.toMyselfSelected,
              binary: true
            }, null, 8, ["modelValue", "onChange"]),
            _hoisted_3
          ])
        ]),
        _hoisted_4,
        _createElementVNode("div", null, [
          _createVNode(_component_UserAutocomplete, {
            modelValue: _ctx.adminSelected,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.adminSelected = $event)),
            params: _ctx.userFilters,
            queryOpts: _ctx.usersQueryOpts,
            onSelect: _ctx.onAdminSelected
          }, null, 8, ["modelValue", "params", "queryOpts", "onSelect"])
        ])
      ])
    ]),
    _: 1
  }, 16))
}